export default __webpack_public_path__ + "static/media/loserfruit.84f16fda.mp4";